<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="true"
      :title="'Verify number'"
    />

    <main
      :class="'scrollable container'"
      :style="{paddingTop: '20px', paddingBottom: '20px'}"
    >
      <span
        :class="'t16'"
        :style="{marginBottom: '30px', display: 'block'}"
        >Enter your OTP code here.</span
      >
      <ul
        :class="'row-center'"
        :style="{gap: '13px', marginBottom: '30px'}"
      >
        <li
          v-for="input in inputs"
          :key="input.id"
          :style="{
            width: '100%',
            height: '60px',
            borderRadius: '10px',
            backgroundColor: 'var(--white-color)',
            border: '1px solid #FFEFE6',
          }"
        >
          <input
            :type="'text'"
            maxlength="1"
            size="1"
            :style="{
              width: '100%',
              height: '100%',
              borderRadius: '10px',
              border: 'none',
              backgroundColor: 'var(--white-color)',
              textAlign: 'center',
              fontSize: '20px',
              color: 'var(--main-dark)',
            }"
          />
        </li>
      </ul>
      <div>
        <span :class="'t16'">Didn’t receive the OTP? Resend.</span>
        <span
          :class="'t16 clickable'"
          :style="{color: 'var(--main-color)'}"
        >
          Resend.</span
        >
      </div>
      <Button
        :title="'Confirm'"
        :onClick="() => $router.push(routes.SIGN_UP_ACCOUNT_CREATED)"
        :containerStyle="{marginTop: '30px'}"
      />
    </main>
  </div>
</template>

<script setup>
// components
import {Header} from '@/components';
import {Button} from '@/components';
import {Background} from '@/components';

// others
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

const opacity = useOpacity();

const inputs = ['1', '2', '3', '4', '5'];
</script>
